import { Component } from '@angular/core';
import { AnalyticsService } from '../../../services/analytics.service';

@Component({
  selector: 'app-kpi-events-summary',
  templateUrl: './kpi-events-summary.component.html',
  styleUrl: './kpi-events-summary.component.scss',
})
export class KpiEventsSummaryComponent {
  isLoading = true;

  constructor(protected analyticsService: AnalyticsService) {
    this.analyticsService.eventsKpisSummary$.subscribe((data) => {});
    this.analyticsService.isLoading$.subscribe((loading) => {
      this.isLoading = loading.includes('eventsKpisSummary');
    });
    this.getChartData();
  }

  getChartData() {
    this.analyticsService.getEventsKpisSummary().subscribe();
  }

  get data() {
    return this.analyticsService.eventsKpisSummary$.value?.data || [];
  }
}
